document.addEventListener('DOMContentLoaded', () => {
    // Disabled: Dropdown for products with many variants
    return;

    const MOBILE_QUERY_STRING = '(max-width: 990px)';
    const mediaQuery = window.matchMedia ? window.matchMedia(MOBILE_QUERY_STRING) : null;
    const isMobileViewport = () => (mediaQuery ? mediaQuery.matches : window.innerWidth <= 990);

    const PANEL_WIDTH = 146;
    const PANEL_HEIGHT = 303;
    const PANEL_MARGIN = 16;

    const selectionState = new Map();

    const getSectionId = (group) => {
        if (!group) return '';
        const container = group.closest('variant-selects');
        return container ? container.getAttribute('data-section') || container.id || '' : '';
    };

    const getGroupKey = (group) => {
        if (!group) return '';
        const sectionId = getSectionId(group);
        const optionIndex = group.getAttribute('data-option_index') || group.getAttribute('data-option-index') || '0';
        return `${sectionId}:${optionIndex}`;
    };

    const getPanel = (group) => (group ? group.querySelector('[data-mobile-dropdown-panel]') : null);
    const getTrigger = (group) => (group ? group.querySelector('[data-mobile-trigger]') : null);
    const getArrowTrigger = (group) => (group ? group.querySelector('[data-mobile-arrow]') : null);
    const getAllGroups = () => Array.from(document.querySelectorAll('[data-mobile-dropdown]'));

    const getSelectionText = (panel) => {
        if (!panel) return '';
        const selectedRadio = panel.querySelector('input[type="radio"]:checked');
        if (selectedRadio && selectedRadio.value) {
            return selectedRadio.value.trim();
        }
        const selectedOption = panel.querySelector('select option[selected], select option:checked');
        if (selectedOption && selectedOption.textContent) {
            return selectedOption.textContent.trim();
        }
        return '';
    };

    const syncBodyScrollState = () => {
        // Body scroll state synchronization removed to prevent visual bugs
    };

    const updateTriggerText = (group) => {
        if (!group) return;
        const displayTarget = group.querySelector('[data-mobile-selected]');
        const panel = getPanel(group);
        if (!displayTarget || !panel) return;

        const placeholder = displayTarget.getAttribute('data-default-value') || '';
        const key = getGroupKey(group);
        const selectionFromDom = getSelectionText(panel);
        let selectionText = selectionFromDom;

        if (selectionFromDom) {
            selectionState.set(key, { value: selectionFromDom, userSelected: true });
        } else {
            const state = selectionState.get(key);
            if (state && state.value) {
                selectionText = state.value;
            }
        }

        if (selectionText) {
            group.dataset.mobileUserSelected = 'true';
            displayTarget.textContent = selectionText;
        } else {
            group.dataset.mobileUserSelected = 'false';
            displayTarget.textContent = placeholder;
        }
    };

    const positionPanel = (group) => {
        if (!isMobileViewport()) return;
        const trigger = getTrigger(group);
        const panel = getPanel(group);
        if (!trigger || !panel) return;

        const triggerRect = trigger.getBoundingClientRect();

        const width = PANEL_WIDTH;
        const height = PANEL_HEIGHT;

        const middleY = triggerRect.top + triggerRect.height / 2;
        let top = middleY - height / 2;
        const minTop = PANEL_MARGIN;
        const maxTop = window.innerHeight - height - PANEL_MARGIN;
        if (top < minTop) {
            top = minTop;
        } else if (top > maxTop) {
            top = Math.max(minTop, maxTop);
        }

        let left = triggerRect.left + triggerRect.width / 2 - width / 2;
        const minLeft = PANEL_MARGIN;
        const maxLeft = window.innerWidth - width - PANEL_MARGIN;
        left = Math.min(Math.max(left, minLeft), maxLeft);

        panel.style.width = `${width}px`;
        panel.style.height = `${height}px`;
        panel.style.top = `${Math.round(top)}px`;
        panel.style.left = `${Math.round(left)}px`;
    };

    const closeGroup = (group, { focusTrigger = true } = {}) => {
        if (!group || !group.classList.contains('is-open')) return;

        group.classList.remove('is-open');

        const trigger = getTrigger(group);
        if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
            if (focusTrigger && isMobileViewport()) {
                trigger.focus({ preventScroll: true });
            }
        }

        const arrowTrigger = getArrowTrigger(group);
        if (arrowTrigger) {
            arrowTrigger.setAttribute('aria-expanded', 'false');
            // Update arrow to show down when closed
            const arrowIcon = arrowTrigger.querySelector('.variant-picker__mobile-arrow-icon');
            if (arrowIcon) {
                arrowIcon.textContent = '↓';
            }
        }

        const panel = getPanel(group);
        if (panel) {
            panel.style.top = '';
            panel.style.left = '';
            panel.style.visibility = '';
        }

        syncBodyScrollState();
    };

    const openGroup = (group) => {
        if (!group || !isMobileViewport()) return;

        getAllGroups().forEach((otherGroup) => {
            if (otherGroup !== group) closeGroup(otherGroup, { focusTrigger: false });
        });

        group.classList.add('is-open');

        const trigger = getTrigger(group);
        if (trigger) {
            trigger.setAttribute('aria-expanded', 'true');
        }

        const arrowTrigger = getArrowTrigger(group);
        if (arrowTrigger) {
            arrowTrigger.setAttribute('aria-expanded', 'true');
            // Update arrow to show up when opened
            const arrowIcon = arrowTrigger.querySelector('.variant-picker__mobile-arrow-icon');
            if (arrowIcon) {
                arrowIcon.textContent = '↑';
            }
        }

        const panel = getPanel(group);
        if (panel) {
            panel.style.visibility = 'hidden';
            requestAnimationFrame(() => {
                positionPanel(group);
                panel.style.visibility = 'visible';
                const focusable = panel.querySelector('input:not([disabled]), button:not([disabled]), select:not([disabled])');
                if (focusable) {
                    focusable.focus({ preventScroll: true });
                }
            });
        }

        syncBodyScrollState();
    };

    const syncGroups = () => {
        getAllGroups().forEach((group) => {
            const key = getGroupKey(group);
            if (selectionState.has(key)) {
                group.dataset.mobileUserSelected = 'true';
            }
            updateTriggerText(group);
        });
    };

    syncGroups();

    if (mediaQuery) {
        mediaQuery.addEventListener('change', () => {
            const openGroupEl = document.querySelector('[data-mobile-dropdown].is-open');
            if (openGroupEl) {
                closeGroup(openGroupEl, { focusTrigger: false });
            }
            syncBodyScrollState();
        });
    }

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-mobile-trigger], [data-mobile-arrow]');
        if (!trigger) return;

        const isPrimaryTrigger = trigger.hasAttribute('data-mobile-trigger');

        const group = trigger.closest('[data-mobile-dropdown]');
        if (!group || !isMobileViewport()) return;

        event.preventDefault();
        if (group.classList.contains('is-open')) {
            closeGroup(group, { focusTrigger: isPrimaryTrigger });
            if (!isPrimaryTrigger && isMobileViewport()) {
                trigger.focus({ preventScroll: true });
            }
        } else {
            openGroup(group);
            if (!isPrimaryTrigger && isMobileViewport()) {
                trigger.focus({ preventScroll: true });
            }
        }
    });

    document.addEventListener('keydown', (event) => {
        if (!isMobileViewport()) return;

        const trigger = event.target.closest('[data-mobile-trigger], [data-mobile-arrow]');
        if (trigger) {
            if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                trigger.click();
            }
            return;
        }

        if (event.key === 'Escape') {
            const openGroupEl = document.querySelector('[data-mobile-dropdown].is-open');
            if (openGroupEl) {
                event.preventDefault();
                closeGroup(openGroupEl);
            }
        }
    });

    document.addEventListener('change', (event) => {
        const target = event.target;
        if (!target.matches('input[type="radio"], select')) return;

        const group = target.closest('[data-mobile-dropdown]');
        if (!group) return;

        const panel = getPanel(group);
        const selectionText = getSelectionText(panel);
        const key = getGroupKey(group);

        if (selectionText) {
            selectionState.set(key, { value: selectionText, userSelected: true });
        }

        updateTriggerText(group);

        if (group.classList.contains('is-open') && isMobileViewport()) {
            closeGroup(group);
        }
    });

    const syncSelectionFromDom = () => {
        getAllGroups().forEach((group) => {
            updateTriggerText(group);
        });
    };

    document.addEventListener('variant:change', (event) => {
        const detail = event && event.detail ? event.detail : {};
        const variant = detail.variant;
        const sectionFilter = detail.sectionId || detail.section || detail.section_id || '';

        if (variant && Array.isArray(variant.options)) {
            getAllGroups().forEach((group) => {
                if (!group) return;
                const sectionId = getSectionId(group);
                if (sectionFilter && sectionId && sectionId !== sectionFilter) {
                    return;
                }

                const optionIndex = parseInt(group.getAttribute('data-option_index') || group.getAttribute('data-option-index') || '0', 10);
                const optionValue = variant.options[optionIndex] || '';
                const key = getGroupKey(group);

                if (optionValue && optionValue.length) {
                    selectionState.set(key, { value: optionValue, userSelected: true });
                }

                updateTriggerText(group);
            });
        } else {
            syncSelectionFromDom();
        }

        syncSelectionFromDom();
        syncBodyScrollState();
    });

    const reinitialize = () => {
        syncSelectionFromDom();
        syncGroups();
    };

    const observeDynamicUpdates = () => {
        if (!('MutationObserver' in window) || !document.body) return;

        const isRelevantNode = (node) => {
            if (!node || node.nodeType !== Node.ELEMENT_NODE) return false;
            const element = node;
            return (
                element.matches?.('[data-mobile-dropdown], variant-selects') ||
                element.querySelector?.('[data-mobile-dropdown], variant-selects')
            );
        };

        let pendingSync = false;

        const observer = new MutationObserver((mutations) => {
            const requiresSync = mutations.some((mutation) => {
                if (mutation.type !== 'childList') return false;
                return Array.from(mutation.addedNodes).some((node) => isRelevantNode(node));
            });

            if (!requiresSync || pendingSync) {
                return;
            }

            pendingSync = true;
            requestAnimationFrame(() => {
                reinitialize();
                pendingSync = false;
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };

    observeDynamicUpdates();

    document.addEventListener('shopify:section:load', reinitialize);
    document.addEventListener('shopify:section:reorder', reinitialize);

    document.addEventListener('pointerdown', (event) => {
        if (!isMobileViewport()) return;
        const eventGroup = event.target.closest('[data-mobile-dropdown]');
        if (eventGroup) return;

        const openGroupEl = document.querySelector('[data-mobile-dropdown].is-open');
        if (openGroupEl) {
            closeGroup(openGroupEl, { focusTrigger: false });
        }
    });

    const handleResizeOrScroll = () => {
        if (!isMobileViewport()) {
            const openGroupEl = document.querySelector('[data-mobile-dropdown].is-open');
            if (openGroupEl) {
                closeGroup(openGroupEl, { focusTrigger: false });
            }
            syncBodyScrollState();
            return;
        }

        const openGroupEl = document.querySelector('[data-mobile-dropdown].is-open');
        if (openGroupEl) {
            positionPanel(openGroupEl);
        }
    };

    window.addEventListener('resize', handleResizeOrScroll, { passive: true });
    window.addEventListener('scroll', () => {
        const openGroupEl = document.querySelector('[data-mobile-dropdown].is-open');
        if (openGroupEl) {
            positionPanel(openGroupEl);
        }
    }, { passive: true });
});
